// Extracted from layout/theme.liquid so it is cached across pageviews.
(function initYcMobileMainPriceRow() {
        if (!document.body.classList.contains('yc-product-template')) return;

        const mobileQuery = window.matchMedia('(max-width: 749px)');
        const savePillClass = 'yc-mobile-save-pill';
        const trustStripClass = 'yc-mobile-trust-strip';
        const shippingBadgeClass = 'yc-mobile-shipping-badge';
        const shippingTextClass = 'yc-mobile-shipping-badge__text';
        const inboxHostSelector = 'inbox-online-store-chat#ShopifyChat, #shopify-chat inbox-online-store-chat, #shopify-chat > inbox-online-store-chat';
        const trustCopy = getLocalizedTrustCopy();
        const inboxCopy = getLocalizedInboxCopy();
        let inboxDismissed = false;
        let inboxCloseButton = null;

        function parseMoneyValue(text) {
          if (!text) return NaN;
          const raw = String(text).replace(/\s/g, '').replace(/[^\d.,-]/g, '');
          if (!raw) return NaN;

          const lastComma = raw.lastIndexOf(',');
          const lastDot = raw.lastIndexOf('.');
          let normalized = raw;

          if (lastComma > -1 || lastDot > -1) {
            const decimalSeparator = lastComma > lastDot ? ',' : '.';
            const thousandSeparator = decimalSeparator === ',' ? '.' : ',';
            normalized = normalized.split(thousandSeparator).join('');
            if (decimalSeparator === ',') {
              normalized = normalized.replace(',', '.');
            }
          }

          const value = Number.parseFloat(normalized);
          return Number.isFinite(value) ? value : NaN;
        }

        function getLocalizedTrustCopy() {
          const locale = (document.documentElement.lang || 'en').toLowerCase();
          if (locale.startsWith('ja')) {
            return {
              points: [
                { icon: 'hand', text: '100%手作り' },
                { icon: 'leaf', text: '天然素材と熱帯雨林の恵み' },
                { icon: 'shield', text: '30日間返品対応' },
              ],
              shippingFallback: '11,200円以上のご注文で送料無料',
            };
          }
          if (locale.startsWith('zh')) {
            return {
              points: [
                { icon: 'hand', text: '100%手工制作' },
                { icon: 'leaf', text: '来自于大自然，雨林' },
                { icon: 'shield', text: '30天退货保障' },
              ],
              shippingFallback: 'Free Shipping for order over US$69.99',
            };
          }

          return {
            points: [
              { icon: 'hand', text: '100% Handmade' },
              { icon: 'leaf', text: 'Nature & Rainforest' },
              { icon: 'shield', text: '30-Day Returns' },
            ],
            shippingFallback: 'Free Shipping for order over US$69.99',
          };
        }

        function getLocalizedInboxCopy() {
          const locale = (document.documentElement.lang || 'en').toLowerCase();
          if (locale.startsWith('ja')) {
            return { closeLabel: 'チャットを閉じる' };
          }
          if (locale.startsWith('zh')) {
            return {
              closeLabel: '关闭聊天入口',
            };
          }

          return {
            closeLabel: 'Close chat launcher',
          };
        }

        function getTrustIconMarkup(iconName) {
          if (iconName === 'hand') {
            return `
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7.4 20.2V12a1.3 1.3 0 0 1 2.6 0v3.2"></path>
                <path d="M10 15.2v-5a1.3 1.3 0 1 1 2.6 0v5"></path>
                <path d="M12.6 15v-4a1.3 1.3 0 1 1 2.6 0v4"></path>
                <path d="M15.2 15.3V12a1.3 1.3 0 1 1 2.6 0v4.3c0 2.5-2 4.5-4.5 4.5h-1.5a4.4 4.4 0 0 1-4.4-4.4"></path>
                <path d="M7.4 16.1l-1.9-1.8a1.3 1.3 0 1 0-1.8 1.8l3.7 3.7"></path>
              </svg>
            `;
          }

          if (iconName === 'shield') {
            return `
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 3l7 3v5.6c0 4.4-2.9 8.2-7 9.4-4.1-1.2-7-5-7-9.4V6l7-3z"></path>
                <path d="m8.5 12.2 2.2 2.2 4.8-4.8"></path>
              </svg>
            `;
          }

          return `
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M19 4c-8.7 0-14 4.6-14 12.4 1.8-2.3 4-3.6 6.5-3.8"></path>
              <path d="M8 20c6.6 0 11-5.8 11-16 0 0-3.2 4.9-10.4 7.5"></path>
            </svg>
          `;
        }

        function getShippingAnnouncementText() {
          const selectors = [
            '#header-group .announcement-bar__link',
            '#header-group .announcement-bar__text',
            '.announcement-bar__link',
            '.announcement-bar__text',
          ];

          for (const selector of selectors) {
            const nodes = document.querySelectorAll(selector);
            for (const node of nodes) {
              const text = (node?.textContent || '').replace(/\s+/g, ' ').trim();
              if (!text) continue;
              if (/shipping|包邮|送料無料|versand|livraison/i.test(text)) return text;
            }
          }

          return trustCopy.shippingFallback;
        }

        function getInboxHost() {
          const node = document.querySelector(inboxHostSelector);
          return node instanceof HTMLElement ? node : null;
        }

        function ensureInboxCloseButton() {
          if (inboxCloseButton instanceof HTMLButtonElement && inboxCloseButton.isConnected) {
            return inboxCloseButton;
          }

          inboxCloseButton = document.createElement('button');
          inboxCloseButton.type = 'button';
          inboxCloseButton.className = 'yc-mobile-inbox-close';
          inboxCloseButton.hidden = true;
          inboxCloseButton.setAttribute('aria-label', inboxCopy.closeLabel);
          inboxCloseButton.textContent = '×';
          inboxCloseButton.addEventListener('click', function () {
            inboxDismissed = true;
            syncMobileInboxOffset();
          });
          document.body.appendChild(inboxCloseButton);
          return inboxCloseButton;
        }

        function hideInboxCloseButton() {
          if (!(inboxCloseButton instanceof HTMLButtonElement)) return;
          inboxCloseButton.hidden = true;
        }

        function positionInboxCloseButton(inboxHost) {
          const closeButton = ensureInboxCloseButton();
          const rect = inboxHost.getBoundingClientRect();
          const computed = window.getComputedStyle(inboxHost);
          if (
            !(rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight) ||
            computed.display === 'none' ||
            computed.visibility === 'hidden' ||
            Number.parseFloat(computed.opacity || '1') === 0
          ) {
            closeButton.hidden = true;
            return;
          }

          const isExpanded = rect.width >= Math.min(window.innerWidth * 0.7, 260) || rect.height >= 220;
          const left = isExpanded
            ? Math.max(8, Math.min(window.innerWidth - 44, rect.left + 10))
            : Math.max(8, Math.min(window.innerWidth - 44, rect.left - 18));
          const top = isExpanded ? Math.max(8, rect.top + 10) : Math.max(8, rect.top - 18);
          closeButton.style.left = `${left}px`;
          closeButton.style.top = `${top}px`;
          closeButton.hidden = false;
        }

        function resetInboxInlineStyles(inboxHost) {
          hideInboxCloseButton();
          document.body.classList.remove('yc-mobile-inbox-dismissed');
          if (inboxHost) {
            inboxHost.style.removeProperty('display');
            inboxHost.style.removeProperty('visibility');
            inboxHost.style.removeProperty('opacity');
            inboxHost.style.removeProperty('pointer-events');
            inboxHost.style.removeProperty('transform');
          }

          const chatRoot = document.querySelector('#shopify-chat');
          if (chatRoot instanceof HTMLElement) {
            chatRoot.style.removeProperty('display');
            chatRoot.style.removeProperty('visibility');
            chatRoot.style.removeProperty('opacity');
            chatRoot.style.removeProperty('pointer-events');
            chatRoot.style.removeProperty('transform');
          }
        }

        function syncMobileInboxOffset() {
          const inboxHost = getInboxHost();
          const isMobile = mobileQuery.matches;

          if (!isMobile || !inboxHost) {
            resetInboxInlineStyles(inboxHost);
            return;
          }

          if (inboxDismissed) {
            hideInboxCloseButton();
            document.body.classList.add('yc-mobile-inbox-dismissed');
            return;
          }

          resetInboxInlineStyles(inboxHost);
          positionInboxCloseButton(inboxHost);
        }

        function ensureTrustAndShipping(priceBlock) {
          const stickyRoot = priceBlock.closest('sticky-add-to-cart');
          const stickyBar = stickyRoot?.querySelector('.sticky-add-to-cart__bar');
          const productDetails = priceBlock.closest('.product-details');
          if (!productDetails) return;

          const buyButtonsBlock = productDetails.querySelector('.buy-buttons-block');
          const isStickyContext = Boolean(stickyRoot && stickyBar);
          if (!isStickyContext && (!buyButtonsBlock || !buyButtonsBlock.isConnected)) return;

          const trustStrip = productDetails.querySelector(`.${trustStripClass}`);
          if (trustStrip) {
            trustStrip.remove();
          }

          const nativeStickyShipping =
            isStickyContext && stickyBar ? stickyBar.querySelector('.bw-sticky-shipping-strip') : null;
          if (nativeStickyShipping instanceof HTMLElement) {
            const shippingText = getShippingAnnouncementText();
            let nativeTextNode = nativeStickyShipping.querySelector('span');
            if (!nativeTextNode) {
              nativeTextNode = document.createElement('span');
              nativeStickyShipping.textContent = '';
              nativeStickyShipping.appendChild(nativeTextNode);
            }
            nativeTextNode.textContent = shippingText ? shippingText.replace(/ /g, '\u00A0') : '';
            nativeStickyShipping.classList.toggle('yc-hidden', !shippingText);

            nativeStickyShipping.style.setProperty('grid-area', 'shipping', 'important');
            nativeStickyShipping.style.setProperty('grid-column', '1 / -1', 'important');
            nativeStickyShipping.style.setProperty('width', '100%', 'important');
            nativeStickyShipping.style.setProperty('max-width', 'none', 'important');
            nativeStickyShipping.style.setProperty('min-width', '0', 'important');
            nativeStickyShipping.style.setProperty('display', 'flex', 'important');
            nativeStickyShipping.style.setProperty('justify-content', 'center', 'important');
            nativeStickyShipping.style.setProperty('color', '#55654b', 'important');
            nativeStickyShipping.style.setProperty('white-space', 'nowrap', 'important');
            nativeStickyShipping.style.setProperty('writing-mode', 'horizontal-tb', 'important');

            nativeTextNode.style.setProperty('color', '#55654b', 'important');
            nativeTextNode.style.setProperty('white-space', 'nowrap', 'important');
            nativeTextNode.style.setProperty('word-break', 'keep-all', 'important');
            nativeTextNode.style.setProperty('overflow-wrap', 'normal', 'important');
            nativeTextNode.style.setProperty('display', 'inline-block', 'important');
            nativeTextNode.style.setProperty('writing-mode', 'horizontal-tb', 'important');
            return;
          }

          if (!isStickyContext) {
            productDetails.querySelectorAll(`.${shippingBadgeClass}`).forEach((node) => node.remove());
            return;
          }

          const inlineShippingBadge = productDetails.querySelector('[data-bw-shipping-badge], .bw-loyalty-shipping');
          if (inlineShippingBadge) {
            productDetails.querySelectorAll(`.${shippingBadgeClass}`).forEach((node) => node.remove());
            return;
          }

          const shippingContext = isStickyContext ? 'sticky' : 'main';
          const shippingRoot = isStickyContext ? stickyBar : productDetails;
          const legacyShippingBadge = shippingRoot.querySelector(`.${shippingBadgeClass}:not([data-yc-shipping-context])`);
          if (legacyShippingBadge) {
            legacyShippingBadge.setAttribute('data-yc-shipping-context', shippingContext);
          }

          let shippingBadge = shippingRoot.querySelector(`.${shippingBadgeClass}[data-yc-shipping-context="${shippingContext}"]`);
          if (!shippingBadge) {
            shippingBadge = document.createElement('div');
            shippingBadge.className = shippingBadgeClass;
            shippingBadge.innerHTML = `
              <span class="${shippingBadgeClass}__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M4 8h11v8H4z"></path>
                  <path d="M15 11h2.2l2.3 2.4V16H15z"></path>
                  <circle cx="8" cy="18" r="1.8"></circle>
                  <circle cx="17" cy="18" r="1.8"></circle>
                </svg>
              </span>
              <span class="${shippingTextClass}"></span>
            `;
          }
          shippingBadge.setAttribute('data-yc-shipping-context', shippingContext);

          if (!shippingBadge.querySelector(`.${shippingBadgeClass}__icon`) || !shippingBadge.querySelector(`.${shippingTextClass}`)) {
            shippingBadge.innerHTML = `
              <span class="${shippingBadgeClass}__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M4 8h11v8H4z"></path>
                  <path d="M15 11h2.2l2.3 2.4V16H15z"></path>
                  <circle cx="8" cy="18" r="1.8"></circle>
                  <circle cx="17" cy="18" r="1.8"></circle>
                </svg>
              </span>
              <span class="${shippingTextClass}"></span>
            `;
          }

          Array.from(shippingBadge.childNodes).forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && node.textContent && node.textContent.trim()) {
              node.remove();
            }
          });
          shippingBadge.querySelectorAll('br').forEach((node) => node.remove());

          let shippingTextNode = shippingBadge.querySelector(`.${shippingTextClass}`);
          if (!shippingTextNode) {
            shippingTextNode = document.createElement('span');
            shippingTextNode.className = shippingTextClass;
            shippingBadge.appendChild(shippingTextNode);
          }
          const shippingText = getShippingAnnouncementText();
          const shippingTextForRender = isStickyContext ? shippingText.replace(/ /g, '\u00A0') : shippingText;
          if (shippingTextNode) shippingTextNode.textContent = shippingTextForRender;
          shippingBadge.classList.toggle('yc-hidden', !shippingText);

          shippingBadge.style.whiteSpace = 'nowrap';
          shippingBadge.style.writingMode = 'horizontal-tb';
          if (isStickyContext) shippingBadge.style.setProperty('color', '#55654b', 'important');
          if (shippingTextNode) {
            if (isStickyContext) shippingTextNode.style.setProperty('color', '#55654b', 'important');
            shippingTextNode.style.whiteSpace = 'nowrap';
            shippingTextNode.style.wordBreak = 'keep-all';
            shippingTextNode.style.overflowWrap = 'normal';
            shippingTextNode.style.display = 'inline-block';
            shippingTextNode.style.writingMode = 'horizontal-tb';
          }

          if (isStickyContext) {
            shippingBadge.style.width = '100%';
            shippingBadge.style.maxWidth = 'none';
          }

          try {
            if (isStickyContext) {
              if (shippingBadge.parentElement !== stickyBar) {
                stickyBar.appendChild(shippingBadge);
              }
            } else if (shippingBadge.parentElement !== buyButtonsBlock.parentElement || shippingBadge.previousElementSibling !== buyButtonsBlock) {
              buyButtonsBlock.after(shippingBadge);
            }
          } catch (error) {
            return;
          }
        }

        function cleanupDesktopEnhancements(removeShippingBadges = false) {
          const mainPriceBlocks = document.querySelectorAll('.product-details product-price');
          mainPriceBlocks.forEach((priceBlock) => {
            const priceContainer = priceBlock.querySelector("[ref='priceContainer']");
            if (!priceContainer) return;

            priceContainer.classList.remove('yc-mobile-price-row');
            priceContainer.querySelectorAll(':scope > .yc-sale-group').forEach((node) => node.classList.remove('yc-sale-group'));
            priceContainer
              .querySelectorAll(':scope > .yc-compare-group')
              .forEach((node) => node.classList.remove('yc-compare-group'));
            priceContainer.querySelectorAll(`:scope > .${savePillClass}`).forEach((node) => node.remove());

            const loyaltyWrappers = priceContainer.querySelectorAll(':scope > .bw-loyalty-wrapper');
            loyaltyWrappers.forEach((wrapper) => {
              wrapper.classList.remove('yc-mobile-seeds-inline');
              const loyaltyPill = wrapper.querySelector('.bw-loyalty-earn');
              if (loyaltyPill) loyaltyPill.classList.remove('yc-mobile-seeds-pill');
              if (wrapper.parentElement === priceContainer) priceBlock.appendChild(wrapper);
            });
          });

          document.querySelectorAll(`.${trustStripClass}`).forEach((node) => node.remove());
          if (removeShippingBadges) {
            document.querySelectorAll(`.${shippingBadgeClass}`).forEach((node) => node.remove());
          }
        }

        function updateSavePill(priceContainer) {
          const saleText = priceContainer.querySelector('.yc-sale-group .price')?.textContent || '';
          const compareText = priceContainer.querySelector('.yc-compare-group .compare-at-price')?.textContent || '';
          const saleValue = parseMoneyValue(saleText);
          const compareValue = parseMoneyValue(compareText);
          const savePill = priceContainer.querySelector(`.${savePillClass}`);

          if (!savePill) return;

          const canShow = Number.isFinite(saleValue) && Number.isFinite(compareValue) && compareValue > saleValue && compareValue > 0;
          if (!canShow) {
            savePill.hidden = true;
            savePill.textContent = '';
            return;
          }

          const savePercent = Math.round(((compareValue - saleValue) / compareValue) * 100);
          if (!Number.isFinite(savePercent) || savePercent <= 0) {
            savePill.hidden = true;
            savePill.textContent = '';
            return;
          }

          const locale = (document.documentElement.lang || 'en').toLowerCase();
          savePill.textContent = locale.startsWith('ja') ? `${savePercent}%OFF` : `SAVE ${savePercent}%`;
          savePill.hidden = false;
        }

        function updateLoyaltySeeds(priceContainer) {
          const priceText = priceContainer.querySelector('.yc-sale-group .price')?.textContent ||
            priceContainer.querySelector(':scope .price')?.textContent ||
            '';
          const priceValue = parseMoneyValue(priceText);
          if (!Number.isFinite(priceValue) || priceValue <= 0) return;

          const loyaltyPill = priceContainer.querySelector('.bw-loyalty-earn');
          const seedsValue = loyaltyPill?.querySelector('[data-bw-loyalty-seeds-value], b');
          if (!loyaltyPill || !seedsValue) return;

          const multiplier = Number.parseFloat(loyaltyPill.dataset.bwLoyaltySeedMultiplier || '1');
          const nextSeeds = Math.ceil(priceValue) * (Number.isFinite(multiplier) && multiplier > 0 ? multiplier : 1);
          let nextText = Math.round(nextSeeds).toLocaleString((document.documentElement.lang || 'en').replace('_', '-'));
          if (loyaltyPill.dataset.bwLoyaltyUnit === 'usd') {
            // 100 Seeds = $1.00 store credit; show the money value instead of raw Seeds.
            const cents = Math.round(nextSeeds);
            const part = cents % 100;
            nextText = (loyaltyPill.dataset.bwLoyaltySymbol || '$') + Math.floor(cents / 100) + (part ? '.' + String(part).padStart(2, '0') : '');
          }
          if (seedsValue.textContent.trim() !== nextText) {
            seedsValue.textContent = nextText;
          }
        }

        function enhancePriceBlock(priceBlock) {
          const priceContainer = priceBlock.querySelector("[ref='priceContainer']");
          if (!priceContainer) return;

          const topGroups = Array.from(priceContainer.querySelectorAll(":scope > span[role='group']"));
          const saleGroup = topGroups.find((node) => node.querySelector('.price'));
          const compareGroup = topGroups.find((node) => node.querySelector('.compare-at-price'));

          if (!saleGroup) return;

          priceContainer.classList.add('yc-mobile-price-row');
          saleGroup.classList.add('yc-sale-group');
          compareGroup?.classList.add('yc-compare-group');

          let savePill = priceContainer.querySelector(`:scope > .${savePillClass}`);
          if (!savePill) {
            savePill = document.createElement('span');
            savePill.className = savePillClass;
            savePill.hidden = true;
            priceContainer.appendChild(savePill);
          }

          const loyaltyWrapper =
            priceBlock.querySelector(':scope > .bw-loyalty-wrapper.is-product') ||
            priceBlock.querySelector(':scope > .bw-loyalty-wrapper');

          if (loyaltyWrapper) {
            loyaltyWrapper.classList.add('yc-mobile-seeds-inline');
            const loyaltyPill = loyaltyWrapper.querySelector('.bw-loyalty-earn');
            if (loyaltyPill) loyaltyPill.classList.add('yc-mobile-seeds-pill');
            if (loyaltyWrapper.parentElement !== priceContainer) {
              priceContainer.appendChild(loyaltyWrapper);
            }
          }

          updateSavePill(priceContainer);
          updateLoyaltySeeds(priceContainer);
          ensureTrustAndShipping(priceBlock);
        }

        function refreshMainPriceRow() {
          const isMobile = mobileQuery.matches;
          const isProductTemplate = document.body.classList.contains('yc-product-template');
          if (!isProductTemplate) {
            cleanupDesktopEnhancements(true);
            return;
          }

          const mainPriceBlocks = document.querySelectorAll('.product-details product-price');
          mainPriceBlocks.forEach((priceBlock) => enhancePriceBlock(priceBlock));
        }

        let frame = 0;
        let idleFrame = 0;
        let mainObserver = null;
        let chatObserver = null;
        let chatMountObserver = null;
        let stickyStateObserver = null;
        let observedMainRoot = null;
        let observedStickyNode = null;

        function runWhenIdle(callback) {
          if ('requestIdleCallback' in window) {
            return window.requestIdleCallback(callback, { timeout: 500 });
          }
          return window.setTimeout(callback, 120);
        }

        function scheduleRefresh() {
          if (frame) return;
          frame = window.requestAnimationFrame(function () {
            frame = 0;
            try {
              syncMobileInboxOffset();
            } catch (error) {
              console.error('YC inbox close sync failed', error);
            }

            if (idleFrame) return;
            idleFrame = runWhenIdle(function () {
              idleFrame = 0;
              try {
                refreshMainPriceRow();
              } catch (error) {
                console.error('YC main price row refresh failed', error);
              }
            });
          });
        }

        function bindMainObserver() {
          const nextRoot =
            document.querySelector('.product-details product-price') ||
            document.querySelector('.product-details variant-picker') ||
            document.querySelector('sticky-add-to-cart') ||
            document.querySelector('.product-details');
          if (!nextRoot || nextRoot === observedMainRoot) return;

          mainObserver?.disconnect();
          mainObserver = new MutationObserver(scheduleRefresh);
          mainObserver.observe(nextRoot, {
            attributes: true,
            attributeFilter: ['class', 'style', 'data-stuck', 'data-selected-variant'],
            childList: true,
          });
          observedMainRoot = nextRoot;
        }

        function bindChatObserver() {
          const chatRoot = document.querySelector('#shopify-chat');
          if (!(chatRoot instanceof HTMLElement)) return;
          if (chatRoot === chatObserver?.targetNode) return;

          chatObserver?.disconnect();
          chatObserver = new MutationObserver(scheduleRefresh);
          chatObserver.targetNode = chatRoot;
          chatObserver.observe(chatRoot, {
            attributes: true,
            attributeFilter: ['class', 'style', 'open', 'aria-expanded'],
          });
        }

        function bindStickyStateObserver() {
          const stickyNode = document.querySelector('sticky-add-to-cart [ref="stickyBar"], sticky-add-to-cart .sticky-add-to-cart__bar');
          if (!(stickyNode instanceof HTMLElement)) {
            stickyStateObserver?.disconnect();
            stickyStateObserver = null;
            observedStickyNode = null;
            return;
          }
          if (stickyNode === observedStickyNode) return;

          stickyStateObserver?.disconnect();
          stickyStateObserver = new MutationObserver(scheduleRefresh);
          stickyStateObserver.observe(stickyNode, {
            attributes: true,
            attributeFilter: ['class', 'style', 'data-stuck'],
          });
          observedStickyNode = stickyNode;
        }

        function refreshWithScopedObservers() {
          bindMainObserver();
          bindChatObserver();
          bindStickyStateObserver();
          scheduleRefresh();
        }

        if (typeof mobileQuery.addEventListener === 'function') {
          mobileQuery.addEventListener('change', refreshWithScopedObservers);
        } else if (typeof mobileQuery.addListener === 'function') {
          mobileQuery.addListener(refreshWithScopedObservers);
        }

        window.addEventListener('pageshow', refreshWithScopedObservers);
        window.addEventListener('resize', refreshWithScopedObservers);
        window.addEventListener('orientationchange', refreshWithScopedObservers);
        window.addEventListener('yc:mobile-floating-update', refreshWithScopedObservers);
        document.addEventListener('variant:update', refreshWithScopedObservers);
        document.addEventListener('variant:selected', refreshWithScopedObservers);
        document.addEventListener('cart:update', refreshWithScopedObservers);
        document.addEventListener('quantity-selector:update', refreshWithScopedObservers);
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', refreshWithScopedObservers);
        }

        chatMountObserver = new MutationObserver(function () {
          const chatRoot = document.querySelector('#shopify-chat');
          if (!(chatRoot instanceof HTMLElement)) return;
          bindChatObserver();
          scheduleRefresh();
          chatMountObserver?.disconnect();
          chatMountObserver = null;
        });
        chatMountObserver.observe(document.body, { childList: true });

        refreshWithScopedObservers();
      })();
